import { GeoModelJobStatus, InvalidItem } from "../models/GeoModelJob";

// Fallback only — the job's own errorMessage is preferred, since it names the right entity and
// carries the backend's Zone advice. Kept entity-neutral: sticks use this reason too.
export const NO_WELLS_IN_GEO_MODEL_TOOLTIP =
  "The calculation produced no values. The selected items may not have values for the " +
  "selected Zone. Check that the inputs are correct, then run the calculation again.";

/**
 * EVA-255: mirrors BaseMeshConsumer.IsOutsideGeoModelFailure, which gates the support alert on
 * the same condition — so what the user sees and what support hears agree.
 */
export function isNoWellsInGeoModel(
  status?: Maybe<string>,
  invalidItems?: Maybe<InvalidItem[]>
): boolean {
  if (status !== GeoModelJobStatus.Error) {
    return false;
  }

  // An Error with no items is a thrown failure carrying a reason instead — never this case.
  return (
    !!invalidItems &&
    invalidItems.length > 0 &&
    invalidItems.every((item) => item.reason === "EmptyXdaResult")
  );
}
